import { ComponentType, lazy } from "react"

import { whenPreloadErrorReloadCancelled } from "./preloadErrorReload"

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const lazily = <T extends Record<string, any>>(loader: () => Promise<T>) =>
  new Proxy({} as unknown as T, {
    get: (_, moduleName: string) => {
      const LazyComponent = lazy(() =>
        loader().then(
          (x) => ({
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            default: x[moduleName] as ComponentType<any>,
          }),
          async (error: unknown) => {
            // A chunk that failed to load makes `main.tsx` reload the page, so keep suspending
            // rather than flash the error until it does. Should the reload not happen, show it.
            await whenPreloadErrorReloadCancelled()
            throw error
          }
        )
      )

      // Add `displayName` for React developer component tree
      if (LazyComponent) {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        ;(LazyComponent as ComponentType<any>).displayName = moduleName
      }

      return LazyComponent
    },
  })
